export const messages = {
    "shared-link.footer.link.install": "Prøv {brandName} gratis",
    "shared-link.footer.link.mobile": "{brandName} til mobil",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Beskyttede data",
    "shared-link.password-dialog-box.message": "Angiv adgangskoden for at få adgang til de delte data",
    "shared-link.password-dialog-box.hint.password": "Adgangskode",
    "shared-link.password-dialog-box.message.invalid-password": "Adgangskoden er forkert",
    "shared-link.form.button.open": "Åbn",
    "shared-link.page-not-found.title": "Siden blev ikke fundet",
    "shared-link.page-not-found.message.main": "Den side, du søgte efter, blev ikke fundet.",
    "shared-link.page-not-found.message.description": "Linket kan være forældet, eller du kan have indtastet adressen forkert.",
    "shared-link.page-not-found.message.error": "Fejlkode: 404",
    "shared-link.restore-file.label.size": "Størrelse",
    "shared-link.restore-file.button.restore": "Download",
    "shared-link.links-table.column.name": "Navn",
    "shared-link.links-table.column.size": "Størrelse",
    "shared-link.links-table.action.restore": "Download",
    "shared-link.links-table.action.restore-all": "Download alle",
    "shared-link.side-bar.selected.title:plural": "{count} elementer er valgt | {count} element er valgt | {count} elementer er valgt",
    "shared-link.links-table.label.size": "Størrelse",
    "shared-link.links-table.message.empty-folder": "Denne mappe er tom"
};
